<div class="d-flex justify-content-end flex-sm-row flex-column">
    <button *ngIf="this.exibeBotaoSalvar()" class="btn btn-success mx-2 mb-1" (click)="salvar()"
        [disabled]="!valid || (form && form.invalid)"><i class="fa fa-check mx-2"></i>{{(salvarButtonTitle === '' ? 'Salvar' :
        salvarButtonTitle)}}</button>
    <button *ngIf="this.exibeBotaoCancelar()" class="btn btn-danger mx-2 mb-1" (click)="voltar()"><i class="fa fa-times mx-2"></i>
        {{(cancelarButtonTitle === '' ? 'Cancelar' :
        cancelarButtonTitle)}}
    </button>
</div>
